module.exports = __webpack_public_path__ + "static/img/icon_passcard.d5ffcfa7.png";